module.exports = __webpack_public_path__ + "7e62af7020129b74354784c71a1eba2c.fbx";